/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keyword_Optimizer_How_It_Works_TitleInputs */

const en_keyword_optimizer_how_it_works_title = /** @type {(inputs: Keyword_Optimizer_How_It_Works_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How it works`)
};

const de_keyword_optimizer_how_it_works_title = /** @type {(inputs: Keyword_Optimizer_How_It_Works_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`So funktioniert's`)
};

const fr_keyword_optimizer_how_it_works_title = /** @type {(inputs: Keyword_Optimizer_How_It_Works_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment ça marche`)
};

const es_keyword_optimizer_how_it_works_title = /** @type {(inputs: Keyword_Optimizer_How_It_Works_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cómo funciona`)
};

const it_keyword_optimizer_how_it_works_title = /** @type {(inputs: Keyword_Optimizer_How_It_Works_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come funziona`)
};

const nl_keyword_optimizer_how_it_works_title = /** @type {(inputs: Keyword_Optimizer_How_It_Works_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zo werkt het`)
};

const pl_keyword_optimizer_how_it_works_title = /** @type {(inputs: Keyword_Optimizer_How_It_Works_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jak to działa`)
};

const fi_keyword_optimizer_how_it_works_title = /** @type {(inputs: Keyword_Optimizer_How_It_Works_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Näin se toimii`)
};

const da_keyword_optimizer_how_it_works_title = /** @type {(inputs: Keyword_Optimizer_How_It_Works_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sådan fungerer det`)
};

const sv_keyword_optimizer_how_it_works_title = /** @type {(inputs: Keyword_Optimizer_How_It_Works_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Så fungerar det`)
};

/**
* | output |
* | --- |
* | "How it works" |
*
* @param {Keyword_Optimizer_How_It_Works_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const keyword_optimizer_how_it_works_title = /** @type {((inputs?: Keyword_Optimizer_How_It_Works_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keyword_Optimizer_How_It_Works_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_keyword_optimizer_how_it_works_title(inputs)
	if (locale === "fr") return fr_keyword_optimizer_how_it_works_title(inputs)
	if (locale === "es") return es_keyword_optimizer_how_it_works_title(inputs)
	if (locale === "it") return it_keyword_optimizer_how_it_works_title(inputs)
	if (locale === "nl") return nl_keyword_optimizer_how_it_works_title(inputs)
	if (locale === "pl") return pl_keyword_optimizer_how_it_works_title(inputs)
	if (locale === "fi") return fi_keyword_optimizer_how_it_works_title(inputs)
	if (locale === "da") return da_keyword_optimizer_how_it_works_title(inputs)
	if (locale === "sv") return sv_keyword_optimizer_how_it_works_title(inputs)
	return en_keyword_optimizer_how_it_works_title(inputs)
});